module.exports = __webpack_public_path__ + "img/lock-level.4dbf94cf.png";